import { render, staticRenderFns } from "./CouponGiftModal.vue?vue&type=template&id=0dc9e032"
import script from "./CouponGiftModal.vue?vue&type=script&lang=js"
export * from "./CouponGiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/rouvenpajewski/Documents/Projekte/kuipers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc9e032')) {
      api.createRecord('0dc9e032', component.options)
    } else {
      api.reload('0dc9e032', component.options)
    }
    module.hot.accept("./CouponGiftModal.vue?vue&type=template&id=0dc9e032", function () {
      api.rerender('0dc9e032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/vue/CouponGiftModal.vue"
export default component.exports